import { useEffect, useState } from "react";
import { LuRefreshCcw } from "react-icons/lu";
import {
  useProjectActions,
  useProjectId,
  useProjectMessages,
} from "../../../core_stores/useProjectStore";
import { useProjectStatus } from "../../../view_stores/useProjectStatusStore";

export default function ProjectChatHistoryLoadingIndicator() {
  const history = useProjectMessages();
  const projectStatus = useProjectStatus();
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  const shouldShowIndicator =
    (history === null || history.length === 0) && projectStatus === null;

  useEffect(() => {
    if (shouldShowIndicator) {
      setShouldRender(true);
      const showTimer = setTimeout(() => setIsVisible(true), 50);
      return () => clearTimeout(showTimer);
    } else {
      setIsVisible(false);
      const hideTimer = setTimeout(() => setShouldRender(false), 200);
      return () => clearTimeout(hideTimer);
    }
  }, [shouldShowIndicator]);

  if (!shouldRender) return null;

  return (
    <div className="flex justify-center">
      <div
        className={`flex items-end gap-1 py-4 px-6 rounded-lg
              bg-light-surface-primary dark:bg-dark-surface-primary
              border border-light-placeholder dark:border-dark-placeholder
              transition-all duration-200 ease-out ${
                isVisible
                  ? "opacity-100 scale-100 translate-y-0"
                  : "opacity-0 scale-95 translate-y-2"
              }`}
      >
        {history !== null && history.length === 0 ? (
          <HistoryNotLoadedContent />
        ) : (
          <LoadingContent />
        )}
      </div>
    </div>
  );
}

function HistoryNotLoadedContent() {
  const projectId = useProjectId();
  const { initialize: initializeProject, dispose: disposeProject } =
    useProjectActions();

  const handleTryAgain = () => {
    const actualProjectId = projectId;
    disposeProject();
    initializeProject(actualProjectId!, null, null);
  };

  return (
    <div className="flex flex-col items-center gap-5">
      <span>History cannot be loaded...</span>
      <button
        id="project-chat-history-loading-indicator-try-again"
        className="flex items-center gap-2
      bg-primary-blue text-white px-4 py-2 rounded-md
      hover:brightness-150 transition-all duration-300"
        onClick={handleTryAgain}
      >
        <LuRefreshCcw className="w-4 h-4" />
        Try again
      </button>
    </div>
  );
}

function LoadingContent() {
  return (
    <>
      <span className="text-sm font-medium">Loading chat history</span>
      <div className="flex items-center gap-1 pb-1">
        <div className="w-1 h-1 rounded-full bg-blue-400 animate-[pulse_1.5s_ease-in-out_infinite_0ms]" />
        <div className="w-1 h-1 rounded-full bg-blue-400 animate-[pulse_1.5s_ease-in-out_infinite_150ms]" />
        <div className="w-1 h-1 rounded-full bg-blue-400 animate-[pulse_1.5s_ease-in-out_infinite_300ms]" />
      </div>
    </>
  );
}
